import getPickUpNotificationHandler from "@NA/Handlers/ADIPickUpNotificationHandler";
import setPickUpNotificationHandler from "@NA/Handlers/ADISetPickUpNotificationHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Radio from "@insite/mobius/Radio";
import RadioGroup from "@insite/mobius/RadioGroup";
import { Button } from "@insite/mobius/index";
import React, { ChangeEvent, useEffect, useState } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";
import { ButtonWrapper } from "@insite/mobius/Button";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";

interface OwnProps {
    handleClose: () => void;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapDispatchToProps = {
    getPickUpNotificationHandler,
    setPickUpNotificationHandler,
};

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

export interface AdiPickUpNotificationStyles {
    buttonGridItem: GridItemProps;
    radioGridItem?: GridItemProps;
}

export const adiPickUpNotificationStyles: AdiPickUpNotificationStyles = {
    buttonGridItem: {
        css: css`
            display: flex;
            gap: 10px;
            padding-top: 0px;
            justify-content: end;
            > ${ButtonWrapper} {
                &:first-child{
                    ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`max-width: 115px;  flex: 1; margin-right: 10px; `,
                    css`max-width: 115px;  flex: 1; margin-right: 10px; `,
                    null,
                    null,
                    null,
                ]);
            }}
                }
                &:last-child{
                    ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css` flex: auto; `,
                    css` flex: auto; `,
                    css` min-width: 136px; `,
                    null,
                    null,
                ]);
            }}
                }
                
            }
            
        `,
    },
    radioGridItem: {
        css: css`
            padding-bottom: 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css` padding-bottom: 31px; `,
                    css` padding-bottom: 31px; `,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
};

const styles = adiPickUpNotificationStyles;

const ADIPickUpNotification = ({ handleClose, getPickUpNotificationHandler, setPickUpNotificationHandler }: Props) => {
    const [pickupEmail, setPickupEmail] = useState("");
    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        setPickupEmail(event.currentTarget.value);
    };
    useEffect(() => {
        handleGetPickUpNotification();
    }, []);

    const handleGetPickUpNotification = () => {
        getPickUpNotificationHandler({
            cartid: "",
            onComplete(result: any) {
                if (result?.result) {
                    const res = result.result.emailPreference ? "email" : "noemail";
                    setPickupEmail(res);
                }
            },
        });
    };
    const handleSetPickUpNotification = () => {
        setPickUpNotificationHandler({
            EmailPreference: pickupEmail === "email",
            isPage: true,
            onSuccess() {
                handleClose();
            },
            CartId: "",
            Email: "",
            ShowCheckoutModal: false
        });
    };
    return (
        <StyledWrapper>
            <GridContainer>
                <GridItem width={12} {...styles.radioGridItem}>
                    <RadioGroup name="email" onChangeHandler={handleOnChange} value={pickupEmail}>
                        <Radio value="email">{translate("Yes, email me")}</Radio>
                        <Radio value="noemail">{translate("No, do not email me")}</Radio>
                    </RadioGroup>
                </GridItem>
                <GridItem width={12} {...styles.buttonGridItem}>
                    <Button onClick={handleClose} variant="secondary">
                        {translate("CANCEL")}
                    </Button>
                    <Button onClick={handleSetPickUpNotification} variant="primary">
                        {translate("UPDATE")}
                    </Button>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ADIPickUpNotification);
